export default __webpack_public_path__ + "static/media/cancel.2bb739f7.svg";